import React, { useState, useCallback } from 'react';
import Modal from 'react-modal';
import axios from 'axios';

import style from './NewsletterModal.module.less';

import x from './assets/x.png';
import newsletter from './assets/newsletter.png';

const NEWSLETTER_URL = 'https://us-central1-eleven-puzzles-website.cloudfunctions.net/newsletter';

interface NewsletterModalProps {
  isOpen: boolean;
  onClose: () => void;
  tags?: string[]; // location on the website, will be added as a tag on Mailchimp. Will help identify sign up form
}

export const NewsletterModal: React.FC<NewsletterModalProps> = (props) => {
  const [email, setEmail] = useState('');
  const [cc0f56a6940e30d95a3a1a7a0_2827db7fbc, setCC] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const onFinished = useCallback(async() => {
    try {
      setLoading(true);
      const tags = [...(props.tags || []), 'website'];

      const response = await axios.post(NEWSLETTER_URL, {
        b_cc0f56a6940e30d95a3a1a7a0_2827db7fbc: cc0f56a6940e30d95a3a1a7a0_2827db7fbc,
        email,
        tags
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.data.status === 'ok') {
        setLoading(false);
        setSuccess(true);
      } else {
        setError('Something went wrong, please try again later');
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError('Something went wrong, please try again later');
      console.error(err);
    }
  }, [email, cc0f56a6940e30d95a3a1a7a0_2827db7fbc]);

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={() => props.onClose()}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)'
        }
      }}
      contentLabel="Newsletter Modal"
    >
      <div className={style.modalContent}>
        {success ? (
          <>
            <h2>Thank you</h2>
            <button className={style.close} type="button" onClick={() => props.onClose()}>
              <img src={x} alt="close" />
            </button>
            <p>Thank you for signing up for our newsletter!</p>
          </>
        ) : (
          <>
            <div className={style.wrapper}>
              <div>
                <img className={style.newsletterImg} src={newsletter} alt="newsletter" />
              </div>
              <div>
                <h2>Join our Newsletter</h2>
                <button className={style.close} type="button" onClick={() => props.onClose()}>
                  <img src={x} alt="close" />
                </button>
                {error ? <div className={style.errorMessage}>{error}</div> : <></>}
                <p>Stay in the loop with everything happening at Eleven Puzzles! By subscribing, you’ll be the first to know about:</p>
                <ul>
                  <li>New game announcements</li>
                  <li>Major development and patch updates</li>
                  <li>Exclusive discounts, content, or offers</li>
                  <li>Other exciting news related to our games</li>
                </ul>
                <p>We value your time - our newsletters are infrequent, typically no more than one email per month. Sign up today and never miss an update!</p>
                <form
                  action="https://elevenpuzzles.us7.list-manage.com/subscribe/post?u=cc0f56a6940e30d95a3a1a7a0&amp;id=2827db7fbc"
                  method="post"
                  target="_blank"
                  onSubmit={(ev) => {
                    ev.preventDefault();
                    onFinished();
                  }}
                >
                  <div className={style.emailInputContainer}>
                    <input
                      disabled={loading}
                      type="email"
                      name="EMAIL"
                      className={style.emailInput}
                      placeholder="Enter your e-mail"
                      onChange={ev => setEmail(ev.target.value)}
                      value={email}
                      required
                    />
                  </div>

                  <div className={style.gdpr}>
                    <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                      <input type="text" name="b_cc0f56a6940e30d95a3a1a7a0_2827db7fbc" tabIndex={-1} value={cc0f56a6940e30d95a3a1a7a0_2827db7fbc} onChange={ev => setCC(ev.target.value)} />
                    </div>
                  </div>

                  <button type="submit" className={style.subscribe} disabled={loading}>{loading ? 'Saving...' : 'Subscribe'}</button>
                </form>
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};
